import PropTypes from "prop-types";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Grid from "@mui/material/Grid";
import SortByDropdown from "../components/SortByDropdown";
import SearchBar from "../components/SearchBar";
import PageSelect from "../components/PageSelect";
import ChatSessionsList from "../components/ChatSessionsList";

function UserChatSessions() {
  return (
    <MKBox component="section" py={3}>
      <MKTypography variant="h4">Gesprekken</MKTypography>
      <MKTypography variant="body2" marginBottom={2}>
        De gesprekken van de gebruiker met de chatbot.
      </MKTypography>
      <Grid container spacing={{ xs: 0, lg: 3 }} sx={{ pt: 2, pb: 3, px: 2, mx: "auto" }}>
        <SortByDropdown />
        <SearchBar />
        <PageSelect />
      </Grid>
      <ChatSessionsList />
    </MKBox>
  );
}

export default UserChatSessions;

UserChatSessions.propTypes = {
  id: PropTypes.string.isRequired,
};
